/**
 * 全局路由配置
 */
import loginRouter from './login_router'
import sysRouter from './sys_router'

import roleRouter from './role_router'
import hrRouter from './hr_router'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter) 
const __dirname = process.env.basePath;
const router = new VueRouter({
  base:"/dito-hr/",
  mode:"history", 
  //各个模块引入各自的路由信息
  routes: [
      ...loginRouter,
      ...sysRouter,
      ...roleRouter, 
      ...hrRouter

  ],
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js